import script from "./Switch.vue?vue&type=script&setup=true&lang=js"
export * from "./Switch.vue?vue&type=script&setup=true&lang=js"

import "./Switch.vue?vue&type=style&index=0&id=40f8e5a0&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3714422101/src/github.com/teknologi-kartu/crm-web-admin-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40f8e5a0"]])

export default __exports__